import { useEffect, useState ,useRef } from "react";
import queryString from "query-string";
import io from "socket.io-client";
import { useHistory } from "react-router-dom";
import StatusBar from "./StatusBar/StatusBar";
import Messages from "./Messages/Messages";
import Input from "./Input/Input";
import OnlineMembers from "./OnlineMembers/OnlineMembers";



let socket;



const Chat = ({ location }) => {
  
  let history = useHistory();
  const messagesEndRef = useRef(null)
  const messageInput = useRef(null)
  const[showModal,setShowModal] = useState(false)
  const [users, setUsers] = useState('')
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState(false)


  // const END_POINT = "http://localhost:5000";
  const END_POINT = "https://tman-chat-app.herokuapp.com/";

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
   
    const { name, room } = queryString.parse(location.search);

    socket = io(END_POINT);

    setName(name);
    setRoom(room);

    socket.emit("join", { name, room }, (error) => {
      if(error) {
        alert(error);
        history.push('/')
      }
     
    });

    return () => {
      // socket.emit("disconnect");
      socket.disconnect();
      socket.off();
      // console.log(socket)
    };
  }, [END_POINT, location.search]);

  useEffect(() => {
    messageInput.current.focus();
     socket.on('message', message => {
      setMessages(messages => [ ...messages, message ]);
      scrollToBottom()
    });
    socket.on("roomData", ({ users }) => {
      setUsers(users);
      console.log(users)
    });
    
  }, []);

  useEffect(()=>{
    message.length > 0 ? socket.emit('typing',room): socket.emit('stopTyping',room)
    
    socket.on('typingMessage',()=>{
      setTyping(true)
    })
    socket.on('stopTypingMessage',()=>{
      setTyping(false)
    })


  },[message,room])

  const sendMessage = (event)=>{
    event.preventDefault()
    if(message){
      socket.emit('sendMessage',message,()=>{
        setMessage('')
        scrollToBottom()
      })
    }
  }

  return (
    <div className="relative sm:w-1/2 sm:mx-auto flex flex-col">
      <StatusBar className="" name={name} setShowModal={setShowModal} users={users} typing={typing} room={room}/>
      
      <div className="relative flex flex-col">
      <div className="mx-5 sm:mx-0 my-20 flex-1 ">
      <Messages className="mt-24" typing={typing} messages={messages} name={name}/>
      </div>
      
      <Input message={message} messageInput={messageInput} sendMessage={sendMessage} setMessage={setMessage}></Input>
      <div ref={messagesEndRef} />
      {users.length && <OnlineMembers showModal={showModal} setShowModal={setShowModal} users={Array.from(users)}></OnlineMembers>}
      </div>
    </div>
  );
};

export default Chat;
